/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gdpr_Review_Auto_OnInputs */

const cs_gdpr_review_auto_on = /** @type {(inputs: Gdpr_Review_Auto_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatická anonymizace je zapnutá.`)
};

const en_gdpr_review_auto_on = /** @type {(inputs: Gdpr_Review_Auto_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatic anonymisation is on.`)
};

/**
* | output |
* | --- |
* | "Automatic anonymisation is on." |
*
* @param {Gdpr_Review_Auto_OnInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gdpr_review_auto_on = /** @type {((inputs?: Gdpr_Review_Auto_OnInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gdpr_Review_Auto_OnInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gdpr_review_auto_on(inputs)
	return cs_gdpr_review_auto_on(inputs)
});